import {
  Component,
  OnInit, SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { formatDate } from '@angular/common';
import {DataSharingService} from '../../services/data-sharing/data-sharing.service';

@Component({
  selector: 'app-ride-leasing-rahmenbedingungen',
  templateUrl: './ride-leasing-rahmenbedingungen.component.html',
  styleUrls: ['./ride-leasing-rahmenbedingungen.component.scss'],
})
export class RIDELeasingRahmenbedingungenComponent
  implements OnInit
{
  @ViewChild('datetime', { static: false }) dateTime;
  viewEncapsulation = ViewEncapsulation.Emulated;



  public JaNeinList = [
    { value: false, display: 'Nein' },
    { value: true, display: 'Ja' }
  ];
  public JaNeinListNumber = [
    { value: 0, display: 'Nein' },
    { value: 1, display: 'Ja' }
  ];
  public erwJaNeinList = [
    { value: 0, display: 'Nein' },
    { value: 1, display: 'Ja' },
    { value: 2, display: 'Ja, ab' },
  ];

  public minDate: string;
  public maxDate: string;
  private oldFairbetrag = 6;
  isNetto = false;
  private fairbetragChanged = false;
  constructor(public dSS: DataSharingService) {

  }



  ngOnInit() {
    const today = new Date();
    this.minDate = formatDate(today, 'yyyy-MM', 'en-US');
    const maxDatum = new Date();
    maxDatum.setFullYear(today.getFullYear() + 3);
    // Set the maxDate to the formatted date in 3 years
    this.maxDate = formatDate(maxDatum, 'yyyy-MM', 'en-US');

  }

  onDateTimeChange(event) {
    const parsedDate = this.parseDateInput(event?.detail?.value);
    this.dSS.selectedDate = parsedDate ?? new Date();
    this.dSS.inputChanged.next(false);
  }

  get selectedDateIsoString(): string | null {
    const parsedDate = this.parseDateInput(this.dSS.selectedDate);
    if (!parsedDate) {
      return null;
    }
    return parsedDate.toISOString();
  }

  update(changes: any): void{

    this.dSS.inputChanged.next(true);
  }

  isLeasingDurationDisabled(): boolean {
    if (!this.dSS?.dienststelle) {
      return false;
    }

    const allowedDurations = String(this.dSS.dienststelle.leasingDuration ?? '')
      .split(';')
      .map((duration) => Number(duration.trim()))
      .filter((duration) => [24, 30, 36, 48].includes(duration));
    const uniqueAllowedDurations = [...new Set(allowedDurations)];

    return uniqueAllowedDurations.length === 1;
  }

  updateFairbetrag(event: any) {
    if (this.dSS.dienststelle.fairbetrag !== 0
      && event) {
      this.oldFairbetrag = this.dSS.dienststelle.fairbetrag;
      this.dSS.dienststelle.fairbetrag = 0;
    } else{

      this.dSS.dienststelle.fairbetrag = this.oldFairbetrag;
    }
    this.fairbetragChanged = true;
    this.dSS.inputChanged.next(true);

  }

  showFairbetrag() {
    if (this.dSS.dsCode === '' ) {
      return true;
    }
    if (this.dSS.bArt === 0 ) {
      return this.dSS.dienststelle.fairbetragBeamte;
    }else {
      return this.dSS.dienststelle.fairbetrag || this.fairbetragChanged;
    }

  }

  hasFairbetrag() {
    if (this.dSS.bArt === 0 ) {
      return !!(this.dSS.dienststelle.fairbetragBeamte);
    }else {
      return !!(this.dSS.dienststelle.fairbetrag);
    }

  }

  private parseDateInput(value: unknown): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }

    const normalized = String(value).trim();
    if (!normalized) {
      return null;
    }

    const nativeParsedDate = new Date(normalized);
    if (!Number.isNaN(nativeParsedDate.getTime())) {
      return nativeParsedDate;
    }

    // Safari can fail on plain `yyyy-MM`, so handle month-only values explicitly.
    const monthOnlyMatch = normalized.match(/^(\d{4})-(\d{2})$/);
    if (!monthOnlyMatch) {
      return null;
    }

    const year = Number(monthOnlyMatch[1]);
    const month = Number(monthOnlyMatch[2]);

    if (
      Number.isNaN(year) ||
      Number.isNaN(month) ||
      month < 1 ||
      month > 12
    ) {
      return null;
    }

    return new Date(year, month - 1, 1);
  }
}
